module.exports = __webpack_public_path__ + "img/fis-black.9f6bd666.svg";